
export default [
  '$resource',
  'resourceActions',
  AccountResource
];

export function AccountResource($resource, resourceActions) {
  return $resource('/api/v1/accounts/:id', { id: '@_id' }, resourceActions);
}

